import { render } from "./FreePopup.vue?vue&type=template&id=473b069f"
import script from "./FreePopup.vue?vue&type=script&lang=js"
export * from "./FreePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__